import I18n from "i18n-js";
import React from "react";
import PaymentGatewayTesterActions from "./actions/PaymentGatewayTesterActions";

class PaymentGatewayTesterForm extends React.Component {

  constructor(props) {
    super(props);

    this.onCancel = this.onCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onGatewayChange = this.onGatewayChange.bind(this);
  }

  getFormCredentialsValue(key) {
    if (this.props.gateway.form_credentials) {
      var credentials = typeof this.props.gateway.form_credentials === 'string' ? JSON.parse(this.props.gateway.form_credentials) : this.props.gateway.form_credentials;
      return credentials[key];
    }
  }

  render() {
    return (
      <div className="form">
        <form className="form-horizontal last" onSubmit={this.onSubmit}>

          <div className="form-group">
            <label className="control-label col-sm-2">Gateway</label>
            <div className="col-sm-4">
              <select className="form-control" name="gatewaySelected" value={this.props.gateway.name} onChange={this.onGatewayChange}>
                {this.renderGatewaySelectOptions()}
              </select>
            </div>
          </div>

          {this.renderForm()}

          <div className="form-group last">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-primary no-ladda" style={{marginLeft: '0'}}>{I18n.t('save')}</button>
              {' '}
              <button type="button" onClick={this.onCancel} className="btn btn-secondary no-ladda">{I18n.t('cancel')}</button>
            </div>
          </div>

        </form>
      </div>
    );
  }

  renderGatewaySelectOptions() {
    if (this.props.gatewayOptions && this.props.gatewayOptions.length) {
      return this.props.gatewayOptions.map((option) => {
        return <option value={option[1]} key={option[0]}>{option[0]}</option>
      });
    }
  }

  renderForm() {
    var formOptions = [];
    var options = this.props.currentGatewayOptions && this.props.currentGatewayOptions.length >= 2 ? this.props.currentGatewayOptions[2] : [];

    if (options && options.length) {
      for (var i = 0, ilen = options.length; i < ilen; i++) {
        formOptions.push(
          <div className="form-group" key={options[i]}>
            <label className="control-label col-sm-2">{I18n.t(options[i])}</label>
            <div className="col-sm-4">
              <input type="text" className="form-control" ref={options[i]} name={options[i]} defaultValue={this.getFormCredentialsValue(options[i])} />
            </div>
          </div>
        );
      };
    };

    return (
      <div>
        {formOptions}

      </div>
    );
  };

  onCancel(event) {
    event.stopPropagation();
    event.preventDefault();
    PaymentGatewayTesterActions.cancelGateway();
  };

  onGatewayChange(event){
    this.props.onGatewayChange(event.target.value);
  }

  onSubmit(event) {
    var options =this.props.currentGatewayOptions && this.props.currentGatewayOptions.length >= 2 ? this.props.currentGatewayOptions[2] : [];
    var params = {};

    if (options && options.length) {
      for (var i = 0, ilen = options.length; i < ilen; i++) {
        params[options[i]] = this.refs[options[i]].value;
      }
    }

    this.props.onSaveGatewayCredentials(this.props.gateway.name, params);
    event.preventDefault();
  }
};

export default PaymentGatewayTesterForm
